<template>
    <div class="rates-info d-flex justify-content-lg-start">
        <i class="icon-exclamation-timer d-flex"></i>

        <div class="d-flex flex-wrap justify-content-center justify-content-lg-start rate-info-text smaller-info">
            <span class="mr-1">
                {{ $t('results.offerBlocks.expiryText') }}
            </span>

            <div v-if="resubmitEnabled">
                <span class="light-text d-none d-md-flex mr-1">
                    • {{ $t('results.offerBlocks.expiryLightText') }}
                </span>

                <span class="light-text d-flex d-md-none mr-1">
                    • {{ $t('results.offerBlocks.mobile.expiryLightText') }}
                </span>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: ['offer', 'resubmitEnabled'],
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import 'v-tooltip/dist/v-tooltip.css';

.icon-exclamation-timer {
    height: 100%;
    margin-right: 5px;
    min-width: 15px;
    position: relative;

    @media screen and (min-width: $bp-medium) {
        min-width: 18px;
        margin-right: 15px;
    }

    &:before {
        content: var(--url-expired);
        left: 50%;
        position: absolute;
        top: calc(50% + 2px);
        transform: translate(-50%, -50%);
        width: 100%;
    }
}

.rates-info {
    border-radius: 30px;
    border: 1px solid #e5e5e5;
    color: #808080;
    font-family: var(--primary-font);
    font-size: rem(14px);
    font-weight: 600;
    margin-bottom: 12px;
    padding: 10px;
    width: 100%;

    @media screen and (min-width: $bp-large) {
        width: initial;
    }

    .smaller-info {
        span {
            font-size: rem(13px);

            @media screen and (min-width: $bp-medium) {
                font-size: rem(14px);
            }
        }
    }

    span {
        color: black;
        font-size: rem(12px);
        font-weight: 600;
        text-align: center;

        @media screen and (max-width: $bp-small) {
            font-size: rem(14px);
        }

        @media screen and (min-width: $bp-medium) {
            font-size: rem(14px);
        }

        &.light-text {
            color: #808080;
        }
    }

    .caveat-text {
        color: var(--primary);
        font-size: rem(14px);
        font-weight: 600;
    }

    .rate-info-text {
        width: 100%;
    }
}
</style>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.v-popper__wrapper {
    max-width: 900px;

    .v-popper__inner {
        font-size: rem(13px);

        div {
            color: white;
        }
    }
}
</style>
